import { render, staticRenderFns } from "./hamtragch_baiguullaga.vue?vue&type=template&id=709ebc4e&"
import script from "./hamtragch_baiguullaga.vue?vue&type=script&lang=js&"
export * from "./hamtragch_baiguullaga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports